import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManageCouponPage = React.lazy(() => import(/* webpackChunkName: "AdminManageCoupon" */ './Page'));
export const AdminManageCoupon = () => (React.createElement(Page, { title: "Administrator Manage Coupon" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminManageCouponPage, null)))));
